export const iconFontAwesomeDevicesHardwareFloppyDisk = (
	<i className="fa-solid fa-floppy-disk"></i>
);
